module.exports = __webpack_public_path__ + "static/media/A5-Portrait-H1.bff87936.png";